module.exports = __webpack_public_path__ + "media/assets/avia/search/children-9a41231624a3b397250ef023bbfbf84b.png";